export const SET_SEARCH_TEXT = 'searchText';
export const SET_ONLY_ATIVOS = 'onlyAtivos';
export const SET_CURRENT_PAGE = 'page';
export const SET_OFFSET = 'offset';
export const SET_FILTER = 'filter';
export const SET_LIST_OPTIONS = 'listOptions';
export const SET_CURRENT_SESSION_STATE = 'sessionState';
export const INIT_STATE = 'initState';
